<div id="reorder-products-pop" class="modal in popup-comp cart-popup" role="dialog" data-backdrop="static"
  style="display: block">
  <div class="modal-dialog reorder-dialog">
    <div class="modal-content">
      <div class="modal-header relative">
        <h4 class="modal-title-top20">Reorder Products</h4>
        <div class="cls-btn" (click)="closeModal()">
          <img [src]="'../../../../assets/icons/'+baseSiteId+'/close.svg'" />
        </div>
      </div>
      <div class="modal-body">
        <p class="reorder-prodcts-guide-txt">
          Indicate the units you need for each product, and then add them to
          your cart.
        </p>
        <div class="row row-20 product-details" id="leftCont-rightNav">
          <div class="col-xs-12 col-sm-12 col-md-12 left-section sm-bd-b0 p0" style="min-height: auto">
            <form id="sanofiReorderForm">
              <div class="slimScrollDiv">
                <ul class="checkout-details checkout-reorder">
                  <li class="cart-block cart-view-block" *ngFor="let reorderData of reoderProductList;let i = index">
                    <div class="row row-20">
                      <div class="col-xs-4 col-sm-1 col-md-1 col-lg-1 pr0 cart_print">
                        <!-- <a href="javascript:void(0)" class="cart_title">
                          <cx-media class="cx-product-image" [container]="reorderData?.url" format="thumbnail"
                            [alt]="reorderData?.baseProductDescription"></cx-media>
                        </a> -->
                        <a href="javascript:void(0)" class="cart_title" (click)="navigatePDP(reorderData?.code)">
                          <div>
                            <!-- <img src="../../../../assets/img/missing_product_img.jpg" class="flu-poster" /> -->
                            <img class="image-align" [src]="getImage(reorderData)">
                          </div>
                        </a>
                      </div>
                      <div class="col-xs-8 col-sm-5 col-md-5 col-lg-5 data-pad">
                        <div class="checkout-data ml-3">
                          <a class="cart_title" (click)="navigatePDP(reorderData?.code)">
                            <div>
                              <h2 [innerHTML]="reorderData?.baseProductName"></h2>
                            </div>
                          </a>
                          <div class="product_txt_cart product_txt_bt">
                            <p>
                              <a class="cart_title" [innerHTML]="reorderData?.baseProductDescription">
                              </a>
                            </p>
                          </div>
                          <p>
                            {{reorderData?.variantProductDescription}}
                          </p>
                          <p><span class="prodCode">{{reorderData?.code}}</span> | {{reorderData?.manufacturer}}</p>
                          <div *ngIf="reorderData?.contract && reorderData?.contract.length > 0">
                            <span><b>Contract group: </b></span>
                            <span
                              *ngIf="reorderData?.contract.length == 1">{{reorderData?.contract[0]?.contractDesc}}</span>
                            <div *ngIf="reorderData?.contract.length > 1">
                              <ng-select [items]="reorderData?.contract" [searchable]="false" [clearable]="false"
                                name="{{'contractId' + reorderData?.code}}" bindLabel="contractDesc"
                                bindValue="contractId" placeholder="Select Contract Group"
                                [(ngModel)]="reorderData.selectedContractId" class="dropdown-contractGroup"
                                (change)="reorderData.selectedContractGroup = $event">
                              </ng-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-6 col-sm-3 col-md-2 col-lg-3">
                        <div class="product-price">
                          <h6>Your price</h6>
                          <section class="price-total">
                            <span *ngIf="!reorderData?.price && !reorderData?.contract">$--</span>
                            <span *ngIf="reorderData?.price && !reorderData?.contract">
                              <span>{{reorderData?.price?.value | currency}}</span> {{reorderData?.price?.currencyIso}}
                              <div class="federal-tax" *ngIf="reorderData?.priceDetailsObj?.fexciseTax?.value">
                                {{reorderData?.priceDetailsObj?.fexciseTax?.value |
                                currency}}/package Federal Excise Tax
                                will be added.</div>
                            </span>
                            <span *ngIf="!reorderData?.price && reorderData?.contract">
                              {{getContractPrice(reorderData.selectedContractGroup)}}
                              <div *ngIf="reorderData?.contract && reorderData.selectedContractGroup?.contractPrice?.formattedValue &&
                                reorderData?.priceDetailsObj?.fexciseTax?.value" class="federal-tax">
                                {{reorderData?.priceDetailsObj?.fexciseTax?.value | currency}}/package Federal Excise
                                Tax will be added.</div>
                            </span>
                          </section>
                        </div>
                        <!-- <p class="prodQtyLmts1 cart-page product-discontinued-txt1" style="display: none">
                          This product has quantity limits
                        </p>
                        <div class="row row-20 qly-view-details cart-page" style="display: none">
                          <div class="col-sm-12 col-md-12 col-lg-12 pr0">
                            <a href="#" title=" " target="" data-toggle="modal" data-backdrop="static"
                              data-target="#quantity-limit-4837-03">
                              <h2>View Details</h2>
                            </a>
                          </div>
                        </div>
                        <span class="green-text cart-gt"></span>
                        <p class="red prd-limit" style="display: none">
                          This product has quantity limits
                        </p>
                        <a class="group-restriction-pop-up" style="display: none">View Details</a> -->
                      </div>
                      <div class="col-xs-5 col-sm-3 col-md-3 col-lg-3 cart-unitPrice">
                        <div class="unitCount-comp" *ngIf="
                    userDetails &&
                    (reorderData?.flu ? reorderData.shipNow?.toLowerCase() == 'on' : true)
                    && prodAvailableForOrder(reorderData) &&
                    (isFormularyCustomer ? reorderData.formularyProduct : true) &&
                    (reorderData?.yellowFever ? isYFauthorized : true)
                  ">
                          <div class="addUnits-head bold-12 units-title">
                            Units
                          </div>
                          <div class="add-units">
                            <span class="minusQty focus timedsbld">
                              <img [src]="'../../../../assets/icons/'+baseSiteId+'/less_new.svg'" aria-hidden="true"
                                [ngClass]="{'disabled-image': number.value == '0' || number.value == ''}"
                                id="{{ 'unitMinus' + reorderData?.code }}" alt="minus_icon"
                                (click)="performQuantityComputation(2,reorderData?.code,reorderData);" />
                            </span>
                            <input type="number" #number [value]="0" class="prod-quantity text-center"
                              (change)="disabled = false"
                              (keyup)="performQuantityComputation(null,reorderData?.code,reorderData);"
                              id="{{ 'prodQuantity' + reorderData?.code }}" appNoMouseScroll />
                            <span class="plusQty focus" tabindex="0">
                              <img [src]="'../../../../assets/icons/'+baseSiteId+'/more.svg'" aria-hidden="true"
                                id="{{ 'unitPlus' + reorderData?.code }}" alt="plus_icon"
                                (click)="performQuantityComputation(1,reorderData?.code,reorderData);" />
                            </span>
                          </div>
                          <div class="count-total">
                            <span data-multiply="10" id="{{ 'noOfDoses' + reorderData?.code }}">
                              {{unitValue(reorderData?.code) ? reorderData?.quantityPerUnit+' '+reorderData?.uom : '0'+'
                              '+reorderData?.uom}}
                            </span>
                          </div>
                        </div>
                        <!-- For non-formulary product  -->
                        <div class="formulary-section" *ngIf="
                      userDetails &&
                      isFormularyCustomer &&
                      !reorderData?.formularyProduct
                      ">
                          <div>
                            <span>This product is not in your formulary.</span>
                          </div>
                          <div>
                            <a [ngbPopover]="popSaveContent" placement="top" #s3="ngbPopover" triggers="manual"
                              popoverClass="savedordermini-popover" (click)="openPopup(s3)">View details</a>
                          </div>
                          <ng-template #popSaveContent>
                            <div class="mb-3">
                              This product request is outside your approved formulary and cannot be ordered at this
                              time. Please talk to your Contract Administrator/Purchasing Department to add products to
                              your approved formulary.
                            </div>
                            <a (click)="navigateFormulary()">View your current approved products</a>
                            <div class="mt-2 mb-3">
                              For more information contact <span *ngIf="baseSiteId == 'vsh'">1-800-VACCINE
                                (1-800-822-2463)</span><span *ngIf="baseSiteId == 'vax'">1-800-752-9338</span>
                            </div>
                          </ng-template>
                        </div>

                        <div *ngIf=" 
                      userDetails && 
                      (isFormularyCustomer ? reorderData.formularyProduct : true) &&
                      (reorderData?.yellowFever && !isYFauthorized)
                      " class="col-sm-5 p-0" [ngStyle]="{'font-size': '14px'}">
                          <span>Our records indicate that you are not authorized by your State Health Department to
                            purchase Yellow Fever vaccine. To purchase Yellow Fever vaccine, your practice must be
                            certified by your State Health Department, and Sanofi Pasteur must receive proof of this
                            certification directly from the issuing State Health Department. Please call Customer
                            Service at {{ baseSiteId == 'vsh' ? '1-800-VACCINE (1-800-822-2463)' : '1-800-752-9338'}} to
                            obtain contact information for the appropriate party at your State Health Department who can
                            assist you with this process.</span>
                        </div>
                        <!-- ------------- -  -->
                        <!-- Restriction Errors -->
                        <div *ngIf="userDetails &&
                    !prodAvailableForOrder(reorderData) &&
                    (isFormularyCustomer ? reorderData.formularyProduct : true) &&
                    (reorderData?.yellowFever ? isYFauthorized : true)
                  ">
                          <ng-container *ngFor="let item of errorMessages(reorderData)">
                            <p [ngStyle]="{ color: '#CA0000', 'font-size.px': '14' }">
                              {{ item }}
                            </p>
                          </ng-container>
                        </div>
                        <!-- --------------- -->
                      </div>
                    </div>
                    <!-- <div class="plp_cart_error_added2">
                      <div class="arrow"></div>
                      <img src="../../../../assets/icons/warning_purple.png" /><span>Your quantity limit has been
                        reached</span>
                    </div>
                    <div class="plp_cart_error_added">
                      <div class="arrow"></div>
                      <img src="../../../../assets/icons/warning_purple.png" /><span>Quantity limit is 'null'
                        Units</span>
                    </div> -->
                  </li>
                </ul>
                <!-- <div class="slimScrollBar"></div>
                <div class="slimScrollRail"></div> -->
              </div>
            </form>
          </div>
        </div>
        <div class="reorder-button-container d-flex flex-column align-items-center">
          <button type="button" class="btn-primary mb-2" [disabled]="disabled || checkoutFlag || blockOrder"
            data-dismiss="modal" (click)="addToCart('checkout')">
            <i class="fa fa-spinner fa-spin" *ngIf="checkoutFlag"></i>
            Checkout
          </button>
          <button type="button" class="btn-secondary mb-1" data-dismiss="modal"
            [disabled]="disabled || addToCartFlag || blockOrder" (click)="addToCart('addToCart')">
            <i class="fa fa-spinner fa-spin" *ngIf="addToCartFlag"></i>
            Add to cart
          </button>
        </div>
      </div>
    </div>
  </div>
</div>